<template>
  <section>
    <v-card>
      <v-card-title>
        <span class="text-h4">
          Bot
          <span class="pl-3 subtitle-1">Info</span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-banner two-line v-if="bot">
          <v-icon slot="icon" color="blue lighten-1" size="42">mdi-telegram</v-icon>
          <span class="title">
            Your bot's
            <b>Telegram</b> link is:
            <a
              :href="`https://t.me/${bot.username}`"
              target="_blank"
            >https://t.me/{{bot.username}}</a>
          </span>
          <br />
          <span>Share this link with those whom you want to have registered with your bot.</span>
          <template v-slot:actions>
            <v-btn
              color="primary"
              text
              @click="copy(`https://t.me/${bot.username}`)"
              v-if="canCopy"
            >Copy Link</v-btn>
          </template>
        </v-banner>
        <v-form ref="form" v-model="valid" @submit.prevent="saveBot" lazy-validation>
          <v-row>
            <v-col class="px-4" cols="12" md="6" align-self="start" v-if="botConfig && botConfig.info">
              <v-textarea
                counter
                auto-grow
                prepend-icon="mdi-information"
                rows="6"
                label="Bot start message"
                hint="(max 512 characters)"
                v-model="botConfig.info.start"
                :rules="descRules"
              ></v-textarea>
              <p class="body-1 px-12 mt-2">
                Users will see this text when the first tap the start button or send the
                <v-chip color="accent">/start</v-chip>command to the bot.
              </p>
              <p class="body-2 px-12 mt-2">
                <v-icon>mdi-information</v-icon>We'll also append some information about that basic commands and where to go next, so no need to include that in your message.
              </p>
            </v-col>
            <v-col class="px-8" cols="12" md="6" v-if="botConfig && botConfig.support">
              <p class="text-h5 text--primary">Support</p>
              <p
                class="body-1"
              >Inevitably, some users will need some help navigating your bot's registration process and other features.</p>
              <p class="body-2">Please provide them with a support option.</p>
              <v-radio-group v-model="botConfig.support.type" mandatory>
                <v-radio label="Telegram user" value="telegram_user"></v-radio>
                <v-radio label="Telegram group" value="telegram_group"></v-radio>
                <v-radio label="Phone" value="phone"></v-radio>
                <v-radio label="Email" value="email"></v-radio>
              </v-radio-group>
              <v-text-field
                :label="`${support('label')}*`"
                :hint="support('hint')"
                v-model="botConfig.support.link"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end">
            <v-btn class="ma-4" type="submit" color="primary" outlined>Save</v-btn>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import { makeGetMixin } from "feathers-vuex";

export default {
  data: () => ({
    valid: false,
    loading: false,
    configId: "botInfo",
    descRules: [
      (v) => v === undefined || v.length <= 512 || "Max 512 characters",
    ],
    aboutRules: [
      (v) => v === undefined || v.length <= 120 || "Max 120 characters",
    ],
    supportLabels: {
      telegram_user: {
        label: "Telegram username",
        hint:
          "Your Telegram username is displayed in your profile and is not created by default, you have to create a username.",
      },
      telegram_group: {
        label: "Telegram group join link",
        hint:
          "Don't use one of your managed groups. Export the group link in your group's settings.",
      },
      phone: {
        label: "Phone number",
        hint: "A contact phone number of a support person or centre.",
      },
      email: { label: "Email", hint: "A support email." },
    },
  }),
  mixins: [makeGetMixin({ service: "configuration", name: "botInfo", id: "configId" })],
  created() {},
  mounted() {},
  computed: {
    botInfoParams() {
      return { query: {} };
    },
    botConfig() {
      return this.botInfo && this.botInfo.config;
    },
    canCopy() {
      return !!navigator.clipboard;
    },
  },
  methods: {
    ...mapActions("app", ["showMessage"]),
    support(prop) {
      return this.supportLabels[this.botConfig.support.type]
        ? this.supportLabels[this.botConfig.support.type][prop]
        : null;
    },
    async saveBot() {
      try {
        await this.botInfo.save();
        this.showMessage({
          text: "Bot saved!",
          color: "success",
          position: "top",
        });
      } catch (error) {
        console.log("Bots forbidden");
      }
    },
    async copy(str) {
      await navigator.clipboard.writeText(str);
      this.showMessage({ text: "Copied to clipboard!", position: "top" });
    },
  },
  watch: {},
  components: {},
  props: {
    bot: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>